import React from 'react';
import { connect } from 'react-redux';
import { Image, BlankSlate, Description } from 'components/_shared/blank_slate';
import { resetData } from 'actions/assign';

const AssignModalBlankSlate = ({ activeStep, ...props }) => {
  const CLEAR_FILTERS_BUTTON = {
    className: 'NewButton NewButton--white',
    children: 'Clear Filter',
    onClick: props.resetFilters,
  };

  const CONFIG = {
    CONTENT: {
      message:
        "We couldn't find any Learning Content that matched your filter criteria",
      image: 'filter',
      action: CLEAR_FILTERS_BUTTON,
    },
    ASSIGNEES: {
      message:
        "We couldn't find any People or Groups that matched your filter criteria",
      image: 'users_filter',
      action: CLEAR_FILTERS_BUTTON,
    },
  };

  const stepConfig = CONFIG[activeStep];

  return (
    <div className="AssignModalBlankSlate">
      <BlankSlate large>
        <Image name={stepConfig.image} />
        <Description>{stepConfig.message}</Description>
        <button type="button" {...stepConfig.action} />
      </BlankSlate>
    </div>
  );
};

const mapStateToProps = state => ({
  activeStep: state.activeStep,
});

const mapDispatchToProps = {
  resetFilters: resetData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssignModalBlankSlate);
